import Vue from "vue"
import Vuex from "vuex"
const Cookies = window.Cookies
import { introStore } from '@/code-lab/component/intro/intro-store.js'
import extendBlocks from '@/service/extend-blocks'
import user from './user'
Vue.use(Vuex)

const notifySystem = {
  namespaced: true,
  state: {
    notifyInstance: [],
    openFile: false,
    currentWhereOfFolderList: '',
    isUpdateData: false,
    targetClickObj: null
  },
  actions: {
    new ({ commit, state }, notify) {
      state.notifyInstance.filter(fl => fl.progress === 100).forEach(fe => {
        commit('remove', { id: fe.id })
      })
      commit('add', notify)
    },
    hide ({ commit, state }, { id }) {
      const tg = state.notifyInstance.find(fd => fd.id === id)
      tg.progress === 100 ? commit('remove', { id }) : commit('update', { id, notify: { hide: true } })
    }
  },
  mutations: {
    targetClickObj (state, payload) {
      Object.assign(state, { targetClickObj: payload })
    },
    isUpdateData (state, payload) {
      Object.assign(state, { isUpdateData: payload })
    },
    currentWhereOfFolderList (state, payload) {
      Object.assign(state, { currentWhereOfFolderList: payload })
    },
    add (state, notify) {
      state.notifyInstance.push(notify)
    },
    update (state, { id, notify }) {
      const index = state.notifyInstance.findIndex(fd => fd.id === id)
      Object.assign(state.notifyInstance[index], notify)
    },
    remove (state, { id }) {
      const index = state.notifyInstance.findIndex(fd => fd.id === id)
      const tg = state.notifyInstance.find(fd => fd.id === id)
      window.clearInterval(tg.timer)
      state.notifyInstance.splice(index, 1)
    },
    openFileHandle (state, payload) {
      state.openFile = payload
    }
  }
}

const myProjectManage = {
    namespaced: true,
    state: {
        myProject: [],
        query: {
            limit: 10,
            page: 1,
        }
    },
    mutations: {
        handleMyProject (state, payload) {
            const judge = payload instanceof Array
            judge
              ? state.myProject.splice(state.myProject.length, 0, ...payload)
              : state.myProject.push(payload)
        },
        deleteMyProject (state, projectId) {
          const index = state.myProject.findIndex(fo => fo.projectId === projectId)
          state.myProject.splice(index, 1)
        },
        handleQuery (state, payload) {
            Object.assign(state.query, payload)
        },
        handleMyProjectManageState (state, { to, letter }) {
            state[to] = letter
        }
    }
}

const quickConnection = {
    namespaced: true,
    state: {
      securityToken: '',
      connectDevices: [],
      switchQuick: false,
      closeState: false,
      socketCode: -1,//-1-quickConnect初始未連線,1-連線中，2-連線成功,3-重連成功,其他錯誤碼
      robotInfo:[]
    },
    getters: {
      getDeviceData(state){
        const {connectDevices, robotInfo} = state;
        console.log("get devices data********");
        if(connectDevices.length !== robotInfo.length){
          return [];
        }
        return connectDevices.map(device => {
          let sn = device.sn;
          let info = robotInfo.find(item => item.sn === sn);
          let o = Object.assign({}, device, info, );
          return Object.assign(o, { isDeploy: o.deployMicroCoding })
        })
      }
    },
    mutations: {
        connectDevices (state, payload) {
          console.log("connectDevices:", payload)
          state.connectDevices = payload;
        },
        switchQuickHandler (state, payload) {
          state.switchQuick = payload
        },
        closeState (state, payload) {
          state.closeState = payload
        },
        socketCode (state, payload) {
          state.socketCode = payload
        },
        setRobotInfo(state, payload){
          console.log("set robot info:", payload);
          state.robotInfo = payload;
        }
    },
    actions: {
      getRobotInfo({commit}, params){
        const config = {
          cmd: "get_robot_info",
          data: params
        };
        console.log("get robot info:", config);
        Vue.prototype.b$.send("quick", config, () => {}, {
          eventName: "ws.cmd.update_robot_info",
          callBack: res => {
            if(res.data){
              commit("setRobotInfo", [res.data])
            } else {
              commit("setRobotInfo", [])
            }
          }
        })
      }
    }
}

const whiteConnection = {
  namespaced: true,
  state: {
    rmsGroups: [],
    socketCode: -1,//-1-quickConnect初始未連線,1-連線中，2-連線成功,3-重連成功,其他錯誤碼
  },
  mutations: {
    setRmsGroups(state, payload){
      console.log('setRmsGroups', payload)
      state.rmsGroups = payload;
    },
      socketCode (state, payload) {
        state.socketCode = payload
      },
  },
  actions: {
  },
  getters: {
    
  },
}

const rmsConnection = {
    namespaced: true,
    state: {
        rmsDevices: [],
        connectDevices: [],
        switch: false,
        allDevice: [],
        rmsGroups: [],
    },
    mutations: {
        allDevice (state, payload) {
          state.allDevice = payload
        },
        HANDLERMSDEVICES (state, payload) {
          state.rmsDevices = payload
        },
        HANDLECONNECTDEVICES (state, payload) {
          state.connectDevices = payload
        },
        switchRmsHandler (state, payload) {
          state.switch = payload
        },
        setRmsGroups(state, payload){
          state.rmsGroups = payload;
        }
    }
}

const teachConnection = {
    namespaced: true,
    state: {
        rmsDevices: [],
        connectDevices: [],
        switch: false
    },
    mutations: {
        HANDLERMSDEVICES (state, payload) {
            state.rmsDevices = payload
        },
        HANDLECONNECTDEVICES (state, payload) {
            state.connectDevices = payload
        },
        switchRmsHandler (state, payload) {
          state.switch = payload
        }
    }
}

const setDevicePlay = {
    namespaced: true,
    state: {
        rmsDevices: [],
        connectDevices: [],
        switch: false
    },
    mutations: {
        HANDLERMSDEVICES (state, payload) {
            state.rmsDevices = payload
        },
        HANDLECONNECTDEVICES (state, payload) {
            state.connectDevices = payload
        },
        switchRmsHandler (state, payload) {
          state.switch = payload
        }
    }
}

const missionList = {
  namespaced: true,
  state: {
    categoryList: {},
    currentCategoryId: null,
    currentMissionId: null,
    resizeTimer: null,
    setSaveStateTimer: null,
    categoryListCp: null,
    updateCurrentId: null
  },
  mutations: {
    update (state, payload) {
      Object.assign(state, payload)
    },
    updateCurrentId (state, updateCurrentId) {
      Object.assign(state, { updateCurrentId })
    }
  }
}

const playItem = {
  namespaced: true,
  state: {
    projectId: "",
    materials: [],
    script: "",
    name: "",
  },
  mutations: {
    updatePlayProject (state, payload) {
      Object.assign(state, { ...state, ...payload  })
    }
  }
}

const extendBlock = {
  namespaced: true,
  state: {
    extendBlockId: null,
    blockList: extendBlocks,
    customerBlocks: []
  },
  getters: {
    blocklyExtendCategory(state){
      const langCode = Cookies.get("langCode") || "zh-TW";
      const customerBlocks = state.customerBlocks;
      const blockList = state.blockList;
      let categories = [];
      
      customerBlocks.forEach(item => {
        let id = item.id;
        let categoryItem = blockList.find(category => category.id === id && category.type === "category");
        if(categoryItem && categoryItem.xml){
          let i18n = (categoryItem.i18n || []).find(lang => lang.langCode === langCode);
          i18n = i18n ? i18n.name : categoryItem.title;
          let categoryXml = `<category name="${i18n}" colour="${categoryItem.colour || "#a8a8ac"}">${categoryItem.xml}</category>`
          categories.push(categoryXml);
        }
        if(item.children){
          let otherBlocks = [];
          item.children.forEach(child => {
            let blockItem = blockList.find(block => block.id === child.id && block.type === "block");
            if(blockItem && blockItem.xml){
              otherBlocks.push(blockItem.xml)
            }
          })
          if(otherBlocks.length > 0){
            otherBlocks = otherBlocks.join();
            categories.push(`<category name="%{BKY_NUWA_CATEGORY_OTHERS}" colour="#a8a8ac">${otherBlocks}</category>`)
          }
        }
      });
      if(categories.length === 0){
        return "";
      }
      categories = categories.join();
      const extendCategory = `<category name="%{BKY_NUWA_CATEGORY_EXTENDS}" colour="%{BKY_NUWA_CATEGORY_DEFAULT_COLOR}" expanded="true">${categories}</category>`;
      return extendCategory;
    }
  },
  mutations: {
    UPDATE_EXTEND_BLOCK_ID(state, payload){
      state.extendBlockId = payload;
    },
    UPDATE_CUSTOMER_BLOCKS(state, payload){
      state.customerBlocks = payload;
    }
  },
  actions: {
    GET_EXTEND_BLOCK({commit}){
      console.log("get extend block");
      return new Promise((resolve, reject) => {
        Vue.prototype.b$.send("tool", {
          cmd: "get_extend_block",
          data: {}
        }, res => {
          let data = [];
          if(res.data){
            data = res.data.data || [];
            resolve();
          } else {
            reject();
          }
          commit("UPDATE_CUSTOMER_BLOCKS", data);
          commit("UPDATE_EXTEND_BLOCK_ID", res.data.extendBlockId || null);
        })
      })
    },
    EDIT_EXTEND_BLOCK({state, dispatch}, data){
      let cmd = "add_extend_block";
      let param = {
          data
      };
      if(state.extendBlockId){
          cmd = "edit_extend_block";
          param.extendBlockId = state.extendBlockId;
      }
      return new Promise((resolve, reject) => {
        Vue.prototype.b$.send("tool", {
          cmd,
          data: param
        }, res => {
            if(res.status && Number(res.status.code) === 0){
              dispatch("GET_EXTEND_BLOCK");
              resolve();
            } else {
              reject();
            }
        })
      })
    }
  }
}

const store = {
  namespaced: true,
  state: {
    langCode: Cookies.get("langCode") || "zh-TW", //当前预览
    workSpace: null, // 工作空间
    workMode: "code", //工作魔术 code-编程模式，mission-任务卡模式
    projectData: { // 档案数据
      name: "",
      version: "",
      script: null,
      projectId: null,
      materials: []
    },
    materialsList: [],
    genCode: "", // 源代码
    isSaved: false, // 档案是否被保存
    isAllowSave: false, // 工作区间是否可以保存
    showCode: false, // 是否显示源代码
    showSimulator: false,
    multiLanguageStore: ["en-US", "zh-CN", "zh-TW", 'ja-JP', 'ko-KR'],
    machineStart: false,
    selectedMenue: null,
    showMissionList: false,
    currentMission: null,
    connectGolbalState: null, // 是否连接上机器人,null-未连线,1-rms连线,2-快速连线,3-white连线
    currentVersion: '',
    groupTeamArr: [],
    isCloudProject: false,
    env$: process.env.BASE_URL,
    tempFamilies: [],//專案中增加的自定義臨時家人
    robotFamilies: [],//快速連線機器人中的家人清單
    usedFamilies: [],//專案初始化是抓去到專案中用到的家人清單
    regularVer: "[·`~～!@#$^¥&*=:;,\\\\[\\].<>/?！……（）——|{}｜【】「」‘；：”“'\"。，、？%+《》]",
    ttsLangCode: "",
    simulatorInitStatus: null,
    webVersion: '0.1.0',
    tools: [],
    userInfo: null
  },
  mutations: {
    setTools (state, value) {
      state.tools = value
    },
    webVersion (state, webVersion) {
      state.webVersion = webVersion
    },
    simulatorInitStatus (state, simulatorInitStatus) {
      state.simulatorInitStatus = simulatorInitStatus
    },
    isCloudProject (state, isCloudProject) {
      Object.assign(state, { isCloudProject })
    },
    groupTeamArr (state, payload) {
      Object.assign(state, { groupTeamArr: payload })
    },
    handleCurrentVersion (state, payload) {
      state.currentVersion = payload;
    },
    SET_LANG_CODE(state, payload) {
      state.langCode = payload;
    },
    //设置工作空间
    SET_WORK_SPACE(state, payload) {
      state.workSpace = payload;
    },
    //更新档案数据
    UPDATE_PROJECT_DATA(state, payload) {
      Object.assign(state.projectData, payload)
      if (payload.materials) {
        state.materialsList = payload.materials.slice(0);
      }
    },
    //更新源代码
    UPDATE_GENCODE(state, payload) {
      state.genCode = payload;
    },
    // 更新档案是否被保存
    UPDATE_IS_SAVED(state, payload) {
      state.isSaved = payload;
    },
    // 更新档案是否可以被保存
    UPDATE_IS_ALLOW_SAVED(state, payload) {
      state.isAllowSave = payload;
    },
    //设置代码显示
    SET_SHOW_CODE(state, payload) {
      state.showCode = !!payload;
    },
    SHOW_SIMULATOR(state, payload) {
      state.showSimulator = payload;
    },
    SHOW_MISSION_LIST(state, payload){
      state.showMissionList = payload;
    },
    SELECTEDMENUERIGHT(state, payload) {
      if(payload === 'mission'){
        state.showMissionList = true;
      } else {
        state.showMissionList = false;
      }
      state.selectedMenue = payload;
    },
    CHANGESTATE(state, { key, value }) {
      state[key] = value;
    },
    //切换工作模式
    SWITCH_WORK_MODE(state, payload) {
      state.workMode = payload || "code";
    },
    handleConnectGolbalState (state, payload) {
      console.log('connectGolbalState -> ', payload)
      state.connectGolbalState = payload
    },
    SET_CURRENT_MISSION(state, payload){
      state.currentMission = payload;
    },
    //设置临时家人清单
    SET_TEMP_FAMILIES(state, payload){
      state.tempFamilies = payload;
    },
    //設置機器人家人清單
    SET_ROBOT_FAMILIES(state, payload){
      state.robotFamilies = payload;
    },
    //設置專案中用到的家人清單
    SET_USED_FAMILIES(state, payload){
        state.usedFamilies = payload
    },
    SET_TTS_LANG_CODE(state, payload){
      state.ttsLangCode = payload;
    },
    setUserInfo(state, payload){
      state.userInfo = payload;
    }
  },
  modules: {
    user,
    notifySystem,
    rmsConnection,
    quickConnection,
    whiteConnection,
    myProjectManage,
    teachConnection,
    setDevicePlay,
    missionList,
    playItem,
    introStore,
    extendBlock
  }
}

export default new Vuex.Store(store)
